var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-state"},[_c('p',{staticClass:"empty-state__text"},[_vm._v("No results found")])])
}]

export { render, staticRenderFns }